export const isInteger = (value: string) => {
  return /^\d*$/.test(value);
};
